const translations = {
  "en": {
    "Pivot Alert": "Pivot Alert",
    "View all": "View all"
  },
  "zh-tw": {
    "Pivot Alert": "反轉訊號",
    "View all": "查看全部"
  }
};

export default translations;
